import React, { useEffect } from "react";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import { tab } from "@testing-library/user-event/dist/tab";


const ShortDisplayReview = ({fontSizeCustom,review}) => {
  const totalRating =
    review?.reduce(
      (totalRatings, singleReview) => totalRatings + singleReview.rating,
      0
    ) / review?.length;
  const totalRatingReFactorying = Math.round(totalRating * 2) / 2;
  
  return (
    <>
      {review?.length !== 0 ? (
        <div
        className="shortReview-div"
        >
          <Stack spacing={0.5}>
            <Rating
              name="half-rating-read"
              value={totalRatingReFactorying}
              precision={0.5}
              size="small"
              sx={{ fontSize: `${fontSizeCustom}px` }}
              readOnly
            />
          </Stack>
          <div style={{ fontSize: `${fontSizeCustom}px` }}>
            (
            {`${
              review?.length > 1
                ? `${review?.length} reviews`
                : `${review?.length} review`
            }`}
            )
          </div>
        </div>
      ) : (
        <div
        className="shortReview-div"
        >
          <Stack spacing={0.5}>
            <Rating
              name="half-rating-read"
              value={0}
              precision={0.5}
              size="small"
              sx={{ fontSize: `${fontSizeCustom}px` }}
              readOnly
            />
          </Stack>
          <div style={{ fontSize: `${fontSizeCustom}px` }}>(0 review)</div>
        </div>
      )}
    </>
  );
};

export default ShortDisplayReview;
